"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogModel = void 0;
class LogModel {
}
exports.LogModel = LogModel;
//# sourceMappingURL=LogModel.js.map